<template>
  <div class="row">
    <!-- 标题-副标题 -->
    <div class="col-md-12">
      <h4 class="title">{{title}}</h4>
      <p class="category">{{category}}</p>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">{{categorySecond}}</div>
      </div>

      <div class="card-body row">
        <!-- 分页 -->
        <div class="col-sm-6">
          <el-select
            class="select-default"
            style="width: 5.5em"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          &nbsp;
          <div style="display: inline-block">
            <el-select
              class="el-select"
              style="width: 8em"
              v-model="currentsearchType"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in searchType"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div style="display:inline-block">
            <fg-input class="input-sm"
                      placeholder="搜索"
                      v-model="searchQuery"
                      @keyup.enter="getData">
            </fg-input>
          </div>
          <p-button @click="getData">搜索</p-button>
        </div>

        <!--搜索 -->
        <div class="col-sm-6">

          <div class="pull-right">
            <!--            <p-button type="info" plain @click="selectGame">-->
            <!--              选择游戏-->
            <!--            </p-button>-->
          </div>
        </div>


        <!-- 表格 -->
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column type="selection" v-model="course">
            </el-table-column>
            <el-table-column v-for="column in GamestableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
            <el-table-column label="渠道分类">

              <template slot-scope="scope">
                <el-select class="el-select" @change="changeChannelType" v-model="scope.row.channel_type" filterable>
                  <el-option v-for="item in channel_typeTable" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="220"
              fixed="right"
              class-name="td-actions"
              label="操作">
              <template slot-scope="props" v-if="uploadbutton">
                <p-button type="danger" size="sm" @click="cractResource(props.$index, props.row)">
                  <i slot="label"></i>线下签名包上传
                </p-button>

              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 底部 -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{page}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"

                        :page-count="pagination.page_count">
          </p-pagination>
        </div>
      </div>
    </div>


    <el-dialog title="线下签名包上传" :visible.sync="dialogResourceVisible" width="640px">
      <el-upload
        class="upload-file"
        ref="upload"
        :action="fileUploadUrl"
        :headers="getToken"
        :data="postData"
        multiple
        :on-success="handleAvatarSuccess"
        :on-progress="handleProgress"
        :on-change="resourceChange"
        :file-list="resoucreList"
        :on-remove="arrRemove"
        accept=".apk"
        :before-upload="beforeupload"
        :auto-upload="false">
        <div slot="tip" class="el-upload__tip">上传签名包,签名包必须以".apk"结尾</div>

        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器
        </el-button>

      </el-upload>
      <div slot="footer" class="dialog-footer">
      </div>
      <el-table :data="targetversiondata" style="width: 100%;">
        <el-table-column>
          <template slot-scope="scope">
            <span style="display: inline-block">targetSDK版本号：</span>
            <fg-input v-model="scope.row.targetversion" style="display: inline-block"></fg-input>
            <span style="display: inline-block; margin-left: 3%">文件名  {{scope.row.apkname}} </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>
<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option, Dialog, Form} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Search from 'src/components/UIComponents/Search/Search.vue'
  import {getFetch} from 'src/util/fetch'
  import {Cookie} from 'src/util/cookie'

  import {upLoadFile} from "../../../../util/upload";
  import PButton from "../../../UIComponents/Button";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Dialog)
  Vue.use(Form)
  export default {
    watch: {
      'targetversiondata'() {

      },
      'dialogResourceVisible'() {
        if (this.dialogResourceVisible) {
          this.uploadbutton = false
        } else {
          this.uploadbutton = true
        }
      },
      'targetversiondata'() {
        //console.log(this.targetversiondata)
      },
      'channelRow.channel_type'() {
        //console.log(this.channelRow.channel_type)
      },
      'pagination.perPage'() {
        this.getData()
      },
      'pagination.currentPage'() {
        this.getData()
      },
    },
    components: {
      PButton,
      PPagination,
      Search,
    },
    computed: {
      GamesData() {
        return this.gamesObj
      },
      queriedData() {
        return this.tableData
      },
      to() {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total() {
        return this.total_count
      },
      page() {
        return `从 ${this.from + 1} 到 ${this.to} 共 ${this.total} 条`
      },

    },
    data() {//定义tabel
      return {
        floor: 'sypt',
        uploadbutton: true,
        targetversiondata: [],
        channelRow: {
          channel_type: '',
        },
        channel_type: '',
        channel_typeTable: [],
        fileUploadUrl: window.Config.host + '/api/apkup/sypt_upload/',
        getToken: {
          token: '',
        },
        temp: '',
        postData: {},
        gamesObj: [],
        resoucreList: [],
        apklist: [],
        title: '第一事业部线下签名包上传',
        category: '',
        categorySecond: '',
        dialogchoseGamesVisible: false,
        dialogResourceVisible: false,
        dialogData: {
          gid: "",
          apkfile: "",
          channel_type: ""
        },
        dialogFile: "",
        dialogapkVisible: false,
        pagination: {//分页
          perPage: 30,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          page_count: 0,
          total: 0
        },
        searchQuery: '',//搜索值
        currentsearchType: '游戏id',
        searchType: ['游戏id', '游戏名'],//搜索字段
        tableColumns: [//列表
          {
            prop: 'gameid',
            label: '游戏id',
            minWidth: 100
          },
          {
            prop: 'name',
            label: '游戏名',
            minWidth: 100
          },
          {
            prop: 'alias',
            label: '游戏别名',
            minWidth: 100
          },
          {
            prop: 'floor',
            label: '所属平台',
            minWidth: 100
          },
          {
            prop: "chanel_type",
            label: "渠道分类",
            minWidth: 100
          },
          {
            prop: 'package_path',
            label: '马甲包地址',
            minWidth: 200
          },
          {
            prop: 'user',
            label: '操作者',
            minWidth: 100
          },
          {
            prop: 'upload_time',
            label: '上传时间',
            minWidth: 100
          },
        ],
        tableData: [],//渲染table数据

        //获取游戏信息批量传输给后台
        course: [],
        total_count: 0,
        num: 0,
        //游戏列表
        GamestableColumns: [
          {
            prop: 'gid',
            label: '游戏ID',
            minWidth: 50
          },
          {
            prop: 'name',
            label: '游戏名',
            minWidth: 50
          },
          {
            prop: 'alias',
            label: '游戏别名',
            minWidth: 50
          },
          {
            prop: 'floor',
            label: '所属楼层',
            minWidth: 50
          },
        ],
      }
    },
    methods: {
      arrRemove(file, fileList) {
        for (let j = 0; j < this.targetversiondata.length; j++) {
          if (this.targetversiondata[j]["apkname"] === file.name) {
            this.targetversiondata.splice(j, 1)
          }
        }
      },
      // changeType(row) {
      //     // this.channelRow.channel_type = row.channel_type
      //     // row.channel_type = this.channel_type
      // },
      changeChannelType(vId) {

        // this.channel_type = vId;
      },
      selectGame() {
        this.dialogchoseGamesVisible = true
      },
      beforeupload(file) {
      },
      //进度条
      handleProgress(event, file, fileList) {

      },
      handleAvatarSuccess(response, file, fileList) {
        //清除属性
        if (response.code == 0) {
          this.num--
          if (this.num === 0) {
            this.resoucreList = [];
            this.targetversiondata = []
            this.dialogResourceVisible = false;
            swal({
              title: '上传成功!',
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
            this.$router.push('/uphistory/syptuphistory')
          }


        }

        // this.getData();
      },

      checkfile(file, filelist) {
        let a = []
        for (let i = 0; i < filelist.length; i++) {
          if (filelist[i].name === file.name) {
            filelist.splice(i, 1)
            for (let j = 0; j < this.targetversiondata.length; j++) {
              if (this.targetversiondata[j]["apkname"] === file.name) {
                this.targetversiondata.splice(j, 1)
              }
            }

          }
        }

      },
      resourceChange(file, fileList) {
        //console.log(file)
        if (file.name.endsWith(".apk")) {
          this.dialogFile = file.raw;
        } else {
          alert("文件格式错误")
          this.checkfile(file, fileList)
        }

        //往文件列表里添加属性
        if (file.status == 'ready') {
          this.targetversiondata.push({"targetversion": '', 'apkname': file.name})
        }

        let temp = 0
        fileList.forEach(item => {
          if (item.name == file.name) {
            ++temp;

            if (temp === 2) {
              alert("不能重复上传两个相同文件")
              this.checkfile(file, fileList)
            }

          }
        })
        //console.log(this.targetversiondata.length)

      },

      getMyToken() {
        this.getToken.token = Cookie().get("token")
      },
      async submitUpload() {

        let _data = {
          floor :this.floor,
          gid: this.dialogData.gid,
          targetSdkVersion: JSON.stringify(this.targetversiondata),
          channel_type: this.channel_type
        }
        this.postData = _data;
        let _temp = []
        for (let i = 0; i < this.targetversiondata.length; i++) {
          if (!this.targetversiondata[i].targetversion) {
            _temp.push(this.targetversiondata[i].targetversion)
          }
        }
        if (_temp.length > 0) {
          alert("版本号不能为空")
        } else {
          this.num = this.targetversiondata.length
          setTimeout(() => {
            this.$refs.upload.submit()
          }, 1000);
        }
      },

      cractResource(index, row) {
        this.dialogData = row;
        this.dialogResourceVisible = true
        this.channel_type = row.channel_type
        this.getMyToken()
      },
      cractApk() {
        this.dialogapkVisible = true
        this.getMyToken()
      },

      changeTotal(length) {
        this.pagination.total = length
      },
      async getData(page, size) {
        page = this.pagination.currentPage
        size = this.pagination.perPage
        // name = this
        // type = this
        // gid = this
        let req_data = {}
        req_data['size'] = size
        req_data['page'] = page
        if (this.searchQuery !== '') {
          if (this.currentsearchType === this.searchType[0]) {
            req_data['type'] = 1
            req_data['gid'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[1]) {
            req_data['type'] = 2
            req_data['name'] = this.searchQuery
          } else {
            console.log('预留')
          }

        }

        let opt = {
          url: "/api/games/syptgames/",
          type: 'GET',
          data: req_data,
          //  如果需要接入第三方的接口，需要添加此参数
          // host:window.Config.homeHost
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {

          this.tableData = []
          for (let i = 0; i < res.data.games.results.length; i++) {
            res.data.games.results[i].channel_type = ""
            this.tableData.push(res.data.games.results[i])
          }
          for (let i = 0; i < res.data.games.results.length; i++) {
            if (res.data.games.results[i].floor == "sypt") {
              res.data.games.results[i].floor = "第一事业部"
            } else if (res.data.games.results[i].floor == "yypt") {
              res.data.games.results[i].floor = "第二事业部"
            }

          }
          this.changeTotal(res.data.games.total_count)
          this.total_count = res.data.games.total_count
          this.pagination.page_count = res.data.games.total_page
          this.getChannelType()
        }
      },
      async getChannelType() {
        let opt = {
          url: "/api/channel/type_channel/",
          type: 'GET',
          data: {
            floor: this.floor
          }

        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i]["channel_type"] = res.data.channel_type[0].channel_category
          }

          this.channel_typeTable = []
          for (let i = 0; i < res.data.channel_type.length; i++) {
            this.channel_typeTable.push(res.data.channel_type[i].channel_category)
          }

        }
      },
    },
    mounted() {
      this.getData();
    }
  }
</script>

